import type { ComponentProps, FC } from 'react';
import { Button, ButtonGroup, Card, CardBanner, Flag } from '@george-labs.com/design-system';

import { getFeatureConfig } from '@luna/feature-config';
import type { Language } from '@luna/i18n';
import { getCurrentLanguage } from '@luna/i18n';

import { handleLanguageChange } from './languageSwitchService';

const ALLOWED_LANGUAGES_FLAG: Record<Language, ComponentProps<typeof Flag>['flag']> = {
    en: Flag.FLAG.GB,
    de: Flag.FLAG.DE,
    cs: Flag.FLAG.CZ,
    hr: Flag.FLAG.HR,
    hu: Flag.FLAG.HU,
    ro: Flag.FLAG.RO,
    sk: Flag.FLAG.SK,
    sr: Flag.FLAG.SR,
    'sr-Latn': Flag.FLAG.SR,
};

export const LanguageSwitch: FC = () => {
    const { allowedLanguages = [] } = getFeatureConfig(({ base }) => base);

    const currentLanguage = getCurrentLanguage();

    if (allowedLanguages.length === 0) {
        return null;
    }

    return (
        <Card nested={false} className="rounded-0">
            <CardBanner>Language switch</CardBanner>
            <Card>
                <ButtonGroup segmented>
                    {allowedLanguages.map((language: Language) => {
                        const handleLanguageButtonClick = () =>
                            handleLanguageChange(language!, currentLanguage);

                        return (
                            <Button
                                key={language}
                                onClick={handleLanguageButtonClick}
                                aria-pressed={language === currentLanguage}
                            >
                                <Flag
                                    className="d-flex align-items-center mx-2"
                                    flag={ALLOWED_LANGUAGES_FLAG[language]}
                                />
                            </Button>
                        );
                    })}
                </ButtonGroup>
            </Card>
        </Card>
    );
};
